import styled from 'styled-components'

export default styled.div`
  width: 100%;
  border-radius: 0.375rem;
  padding: 1rem;
  background: ${(props) => props.theme.palette.grey[50]};
  border: ${(props) => `1px solid ${props.theme.palette.grey[200]}`};
`
